import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import p7 from "../../../assets/image_projets/phone1.jpeg";
import p8 from "../../../assets/image_projets/phone2.jpeg";
import p9 from "../../../assets/image_projets/gc1.jpeg";
import p10 from "../../../assets/image_projets/gc2.jpeg";
import p11 from "../../../assets/image_projets/gc3.jpeg";
import p12 from "../../../assets/image_projets/combGC.jpeg";

export default function GreenChallengerProject() {

    const images = [p12, p7, p9];
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const nextImage = () => {
        setCurrentImageIndex((prev) => (prev + 1) % images.length);
    };

    const prevImage = () => {
        setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="relative flex flex-col lg:flex-row-reverse gap-8 lg:gap-12 items-center mb-20 lg:mb-32"
        >
            {/* Content Section */}
            <div className="w-full lg:w-[40%] space-y-6">
                {/* Title */}
                <motion.h3
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2 }}
                    className="text-4xl sm:text-5xl md:text-6xl font-bold text-white"
                >
                    Green Challenger
                </motion.h3>

                {/* Description */}
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3 }}
                    className="text-gray-300 text-base sm:text-lg leading-relaxed"
                >
                    Application web multi-tenant complète combinant un backend Django robuste et un frontend Next.js et Flutter moderne pour la gestion centralisée partant de la production en passant par la transformation jusque la commercialisation des produits agricoles.
                </motion.p>

                {/* Problem - Solution - Impact */}
                {/* <div className="space-y-4 pt-4">
                    <div className="space-y-2">
                        <h4 className="text-lg sm:text-xl font-semibold text-blue-400">🎯 Problématique</h4>
                        <p className="text-gray-400 text-sm md:text-base leading-relaxed">
                            Les exploitations agricoles manquent d'outils centralisés pour gérer efficacement leurs plantations, suivre la production, et coordonner les équipes sur le terrain.
                        </p>
                    </div>

                    <div className="space-y-2">
                        <h4 className="text-lg sm:text-xl font-semibold text-cyan-400">💡 Solution</h4>
                        <p className="text-gray-400 text-sm md:text-base leading-relaxed">
                            Plateforme web multi-tenant avec architecture Django/Next.js permettant la gestion complète : suivi de production, gestion multi-utilisateurs avec rôles et permissions, analytics avancés, et organisation professionnelle des exploitations.
                        </p>
                    </div>

                    <div className="space-y-2">
                        <h4 className="text-lg sm:text-xl font-semibold text-green-400">📈 Impact</h4>
                        <p className="text-gray-400 text-sm md:text-base leading-relaxed">
                            Centralisation des données agricoles, amélioration de l'efficacité opérationnelle, meilleure prise de décision grâce aux analytics, et scalabilité pour gérer plusieurs exploitations simultanément.
                        </p>
                    </div>
                </div> */}

                {/* Architecture Highlight */}
                {/* <div className="pt-4">
                    <h4 className="text-sm sm:text-base font-semibold text-gray-400 mb-3 uppercase tracking-wider">Architecture</h4>
                    <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-4 space-y-2">
                        <div className="flex items-center gap-2">
                            <span className="text-green-400 font-bold">Backend:</span>
                            <span className="text-gray-300 text-sm md:text-base">Django REST Framework avec PostgreSQL</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="text-blue-400 font-bold">Frontend:</span>
                            <div className="flex flex-col gap-0">
                                <span className="text-gray-300 text-sm md:text-base">Next.js avec SSR et optimisation SEO</span>
                                <span className="text-gray-300 text-sm md:text-base">Flutter pour l'application mobile</span>
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="text-purple-400 font-bold">Logique:</span>
                            <span className="text-gray-300 text-sm md:text-base">Multi-tenancy avec isolation des données</span>
                        </div>
                    </div>
                </div> */}

                {/* Technologies */}
                <div className="pt-4">
                    <h4 className="text-sm sm:text-base font-semibold text-gray-400 mb-3 uppercase tracking-wider">Technologies</h4>
                    <div className="flex flex-wrap gap-2">
                        {["Django", "Next.js", "PostgreSQL", "Django REST", "React", "Multi-tenancy", "TypeScript", "Tailwind CSS"].map((tech, index) => (
                            <span
                                key={index}
                                className="px-3 py-1.5 bg-white/5 backdrop-blur-md border border-white/10 rounded-full text-xs sm:text-sm text-gray-300 hover:bg-white/10 hover:border-white/20 transition-all duration-300"
                            >
                                {tech}
                            </span>
                        ))}
                    </div>
                </div>
            </div>

            {/* Image Carousel Section */}
            <div className="w-full lg:w-[60%] relative group">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl border border-white/10 bg-gradient-to-br from-green-900/20 to-emerald-900/20">
                    {/* Image Container */}
                    <div className="relative h-[400px] sm:h-[500px] lg:h-[600px]">
                        <AnimatePresence mode="wait">
                            <motion.img
                                key={currentImageIndex}
                                src={images[currentImageIndex]}
                                alt={`Green Challenger screenshot ${currentImageIndex + 1}`}
                                initial={{ opacity: 0, scale: 0.95 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 1.05 }}
                                transition={{ duration: 0.5 }}
                                className="w-full h-full object-cover"
                                loading="lazy"
                            />
                        </AnimatePresence>

                        {/* Navigation Buttons */}
                        <button
                            onClick={prevImage}
                            className="absolute left-4 top-1/2 -translate-y-1/2 cursor-pointer bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/20 rounded-full p-3 transition-all duration-300 z-20"
                            aria-label="Image précédente"
                        >
                            <ChevronLeft className="w-6 h-6 text-white" />
                        </button>

                        <button
                            onClick={nextImage}
                            className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/20 rounded-full p-3 transition-all duration-300 z-20"
                            aria-label="Image suivante"
                        >
                            <ChevronRight className="w-6 h-6 text-white" />
                        </button>

                    </div>

                    {/* Dots Indicator */}
                    <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-20">
                        {images.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentImageIndex(index)}
                                className={`w-2 h-2 rounded-full transition-all duration-300 ${index === currentImageIndex
                                    ? "bg-green-400 w-8"
                                    : "bg-white/30 hover:bg-white/50"
                                    }`}
                                aria-label={`Aller à l'image ${index + 1}`}
                            />
                        ))}
                    </div>
                </div>

                {/* Floating badge */}
                <div className="absolute -top-4 -left-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-4 py-2 rounded-full text-xs sm:text-sm font-bold shadow-xl">
                    Application Web
                </div>
            </div>
        </motion.div>
    );
}
